export default class Str {
    static isEmpty(value?: string | null): boolean {
        return !value || value.trim().length === 0;
    }

    static isNotEmpty(value?: string): boolean {
        return !this.isEmpty(value);
    }
}
